import React from 'react'

import CategoryHeader from './CategoryHeader'
import Panel from '../../../../components/structure/Panel'
import RepliesList from '../replies/RepliesList'
import Separator from '../../../../components/helpers/Separator'

const Category = ({ category, hideCategories, props }) => {
  const replies = category.data || []
  const firstLevelReplies = replies.filter(reply => !reply.question?.parentReference)

  if (hideCategories) return <RepliesList replies={firstLevelReplies} allReplies={replies} />

  return (
    <Panel noMargin mediumPadding lineBorder noShadow>
      <CategoryHeader category={category} />

      <Separator weight={8} />
      <RepliesList replies={firstLevelReplies} allReplies={replies} {...props} />
    </Panel>
  )
}

export default Category
